<script>
import { validate } from "vee-validate";

export default {
  props: ['report_id'],
  data() {
    return {
      category: "",
      has_media: null,
      formSent: false,
      formData: {
        name: "",
        email: "",
        comment: "",
        report_id: ""
      },
    };
  },
  mounted() {
    this.formData.report_id = this.report_id;
  },
  methods: {

    sendForm() {
      if (this.loading) {
        console.log("loading..");
        return;
      }
      this.$refs["comment_report"].validate().then((success) => {
        if (success) {
                       this.formSent = true;
          axios
            .post("/reportcomment/", this.formData, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            // .then((response) => {
            //   this.formSent = true;
          
            // })
            .catch((e) => {
              this.formSent = false;
              console.log(e.response.data);
              if (e.response.data.errors) {
                // this.form_errors = e.response.data.errors;
              }
            });
        }
      });
    },

  },
  
};
</script>